import axios from 'axios';
import {Notyf} from 'notyf';
// import jsPDF from "jspdf";
// import domtoimage from 'dom-to-image';
import Swiper from 'swiper';
import SwiperCore, {Navigation, Pagination, Thumbs} from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Thumbs]);

export class compareFinanceMethods {
    constructor()
    {
        this.token = "3LT4dTVMoGwRn";
        this.calculator = document.querySelector('[data-calculator]');
        this.vat = 0;
        this.calculator_form = document.querySelector('[data-calculator-html-form]');
        this.current_payment_type = 'credit';
        this.vw_api_endpoint = 'https://kalkulator.vwbank.pl/vwapi/calculate/';
        this.vw_api_proxy_endpoint = window?.ajax_object?.restUrlVwBankProxy ?? '';
        this.calculator_data = {};

        this.cars_list_wrapper = document.querySelector('[data-cars-list-to-check-finances]');
        this.cars = false;
        this.selected_car = false;
        this.response = false;

        this.current_personal_calculation = {};
        this.personal_calculatios_array = new Array();

        this.notyf = new Notyf({
            duration: 3000,
        });

        this.compare_column_html_template = document.querySelector('[data-table-column-template]');

        this.slider = false;
    }

    init()
    {
        if (!this.checkPageType() || !this.calculator || !this.cars_list_wrapper) {
            return false;
        }

        this.vat = parseFloat(this.calculator.dataset.calculator);

        this.cars = this.cars_list_wrapper.querySelectorAll('[data-finance-car]');
        this.selected_car = this.setCurrentCar(this.cars[0].dataset.financeCar);

        console.info("-> this.selected_car", this.selected_car);

        this.toggleCarFocus(this.selected_car.index);
        this.updateCalculation();
        this.showCalculationsList();

        this.addListeners();
        this.thumbSlider();
        this.calcsSlider();

        console.log("-> this.current_personal_calculation", this.current_personal_calculation);

        const form_inputs = this.calculator_form.querySelectorAll('input');
        [...form_inputs].forEach((input) => {
            input.addEventListener('change', (e) => {
                this.updateCalculation();
            })
        });
    }

    updateCalculation()
    {
        this.calculateCarPayments(this.selected_car.price, this.selected_car.name, this.selected_car.bank_name, this.current_payment_type);
        this.updateTabView();
    }

    updatePersonalCalculation(key, value, title, in_html)
    {
        this.current_personal_calculation[key] = value;
        this.current_personal_calculation[key + '_title'] = title;
        this.current_personal_calculation[key + '_html'] = in_html;
    }

    addListeners()
    {
      // Cars
        this.cars.forEach((car) => {
            car.addEventListener('click', () => {
                this.selected_car = this.setCurrentCar(car.dataset.financeCar);
                this.toggleCarFocus(this.selected_car.index);
                this.updateCalculation();
                this.updateBruttoPriceViewInCals(this.selected_car.price);

            })
        })

      // Tabs
        const options = this.calculator.querySelectorAll('[data-payment-option]');
        [...options].forEach((option) => {
            option.addEventListener('click', (e) => {
                e.preventDefault();
                this.current_payment_type = option.dataset.paymentOption;
                this.updateCalculation();
            })
        });

      // Save Calculation
        let that = this;
        document.querySelectorAll('[data-save-calculation]')[0].addEventListener('click', function (e) {
            e.preventDefault();
            that.addCarToLocalStorageCalculation();
        })

        document.querySelectorAll('[data-save-calculation]')[1].addEventListener('click', function (e) {
            e.preventDefault();
            that.addCarToLocalStorageCalculation();
        })

      // Save PDF compare Calculations
        const savePdfButtons = document.querySelectorAll('[data-download-calc-id]');

        savePdfButtons.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                document.body.style.cursor = 'wait';
                elem.style.cursor = 'wait';

                const ajax_form_data = new FormData();
                ajax_form_data.append('action', 'compareFinancesPDF');
                let current_data = localStorage.getItem('calculations');
                ajax_form_data.append('data', current_data);
                axios.post(ajax_object.ajax_url, ajax_form_data).then((response) => { this.downloadFile(response.data) });

                document.body.style.cursor = "default";
                elem.style.cursor = "default";
            })
        });


        const saveSingleCalculation = document.querySelector('[data-download-single-calc]');
        saveSingleCalculation.addEventListener('click', (e) => {
            e.preventDefault();

            document.body.style.cursor = 'wait';
            saveSingleCalculation.style.cursor = 'wait';

            const ajax_form_data = new FormData();
            ajax_form_data.append('action', 'getSingleFinance');
            let current_data = JSON.stringify(this.current_personal_calculation);
            ajax_form_data.append('data', current_data);
            axios.post(ajax_object.ajax_url, ajax_form_data).then((response) => { this.downloadFile(response.data) });

            document.body.style.cursor = "default";
            saveSingleCalculation.style.cursor = "default";


        }, true)



    }


    downloadFile(uri)
    {
        let name = 'kalkulacja';
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.target = '_blank';
        link.click();
        document.body.removeChild(link);
    }


    updateTabView()
    {
        const options = this.calculator.querySelectorAll('[data-payment-option]');
        [...options].forEach((option) => {
          option.classList.remove('bg-secondary','border-b-primary', 'before', 'before:absolute', 'before:bottom-0', 'before:left-0', 'before:w-full', 'before:h-1', 'before:bg-primary-500', 'text-white');

          if (option.dataset.paymentOption === this.current_payment_type) {
            option.classList.add('bg-secondary','border-b-primary', 'before', 'before:absolute', 'before:bottom-0', 'before:left-0', 'before:w-full', 'before:h-1', 'before:bg-primary-500', 'text-white');
            option.classList.remove('text-secondary');
          }
        })

      // Set Tab Active
        const tabs = this.calculator_form.querySelectorAll('[data-payment-tab]');
        [...tabs].forEach((tab) => {
            tab.style.display = 'none';

            if (tab.dataset.paymentTab === this.current_payment_type) {
                tab.style.display = 'block';
            }
        })
    }

    calculateCarPayments(price, model, bank_name, payment_type)
    {
      // Reset data
        this.calculator_data = {};

        console.info(price, model, bank_name, payment_type);

      // Set New data
        this.calculator_data = {
            'token': this.token,
            'model': bank_name,
            'price': price,
            'km_limit': (this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_limit"]').value) * 1000,
            'rate': this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_loans"]').value,
            'payment': (this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value) / 100,
            'own_contribution': (parseFloat(this.selected_car.price) * parseFloat(this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value)) / 100,
        };


        this.updatePersonalCalculation('loans', this.calculator_data.rate, 'Okres finansowania', this.calculator_data.rate + '&nbsp;msc');
        this.updatePersonalCalculation('own_contribution', this.calculator_data.own_contribution, 'Opłata wstępna brutto', this.calculator_data.own_contribution + '&nbsp;zł&nbsp; <span class="font-light text-xs">(' + parseFloat(this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value) + '% wartości auta)</span>');
        this.updatePersonalCalculation('own_contribution_percentage', parseFloat(this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value));
        this.updatePersonalCalculation('km_limit', parseFloat(this.calculator_data.km_limit / 1000), 'Roczny limit km:', parseFloat(this.calculator_data.km_limit / 1000) + '&nbsp;tys. km');

        // const endpoint = (payment_type == 'credit') ? 'skoda/' : 'skoda_leasing_niskich_rat/';
        // const url = this.vw_api_endpoint + endpoint;

        const endpoint = (payment_type == 'credit') ? 'skoda' : 'skoda_leasing_niskich_rat';
        const url = this.vw_api_proxy_endpoint + '?endpoint=' + endpoint;

        let formData = new FormData();
        formData.append('token', this.calculator_data.token);
        formData.append('model', this.calculator_data.model);
        formData.append('price', this.calculator_data.price);
        formData.append('km_limit', this.calculator_data.km_limit);
        formData.append('rate', this.calculator_data.rate);
        formData.append('payment', this.calculator_data.payment);

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }

        let that = this;

        axios.post(url, formData, config).then(function (response) {
            that.response = response;

            if (payment_type == 'credit') {
                that.animateNumber(document.querySelector('[data-own-contribution="credit"]'), that.calculator_data.own_contribution)
                that.animateNumber(document.querySelector('[data-loan-brutto="credit"]'), response.data.content.rate)
            } else {
                that.animateNumber(document.querySelector('[data-own-contribution="leasing"]'), that.calculator_data.own_contribution)
                that.animateNumber(document.querySelector('[data-loan-brutto="leasing"]'), response.data.content.rate)
                that.animateNumber(document.querySelector('[data-end-value-brutto="leasing"]'), response.data.content.redemption_value)
            }

            that.updatePersonalCalculation('rate', response.data.content.rate, 'Rata miesięczna brutto', response.data.content.rate + '&nbspzł')
            that.updateSummaryView(that.selected_car);

        });
    }

    updateSummaryView(car)
    {


        this.updatePersonalCalculation('thumb', car.photo);
        this.updatePersonalCalculation('name', car.name);
        this.updatePersonalCalculation('price-netto', parseInt((car.price * 100) / (100 + this.vat)), 'Cena netto', parseInt((car.price * 100) / (100 + this.vat)) + '&nbsp;zł');

        let temp_price = ''.concat(car.price, ' ', 'zł')
        this.updatePersonalCalculation('price', car.price, 'Cena brutto', temp_price);


        console.log(this.current_personal_calculation);

      // Finance type
        let type_text = document.querySelector('[data-summary-finance-type]');
        let type_text_json = JSON.parse(type_text.dataset.summaryFinanceType);
        type_text.innerText = type_text_json[this.current_payment_type];

      // Model
        document.querySelector('[data-summary-model-name]').innerText = car.name;

      // Photo
        document.querySelector('[data-summary-car-photo]').src = car['photo_big']['url'];

      // Loan info
        let loan_type_text = document.querySelector('[data-summary-month-loan-title]');
        let loan_type_text_json = JSON.parse(loan_type_text.dataset.summaryMonthLoanTitle);
        loan_type_text.innerText = loan_type_text_json[this.current_payment_type];
        document.querySelector('[data-summary-month-loan-price]').innerHTML = this.response.data.content.rate + '&nbsp;zł/msc';
        document.querySelector('[data-summary-month-loan-netto-price]').innerHTML = parseInt((this.response.data.content.rate * 100) / (100 + this.vat)) + '&nbsp;zł/msc';

        document.querySelector('[data-summary-car-price]').innerHTML = car.price + '&nbsp;zł';
        document.querySelector('[data-summary-car-netto-price]').innerHTML = parseInt((car.price * 100) / (100 + this.vat)) + '&nbsp;zł';


    }


    updateBruttoPriceViewInCals(price)
    {
        document.querySelector('[data-car-brutto-price]').innerHTML = price + 'zł';
    }

    animateNumber(elem, value)
    {
        let current = elem.dataset.currentValue;
        let new_value = parseInt(value);
        elem.innerText = new_value + 'zł';
    }


    setCurrentCar(car_data)
    {
        return JSON.parse(car_data);
    }

    toggleCarFocus(id)
    {
        this.cars.forEach((car) => {
            car.style.cssText = '';
            car.style.opacity = '0.6';
        })

        this.cars[id].style.cssText = 'opacity: 1; border-color: #4ba82e;';
    }

    addCarToLocalStorageCalculation()
    {

        let current_data = JSON.parse(localStorage.getItem('calculations'));
        if (current_data) {
            this.personal_calculatios_array = current_data;

            if (current_data.length >= 3) {
                this.notyf.error('Możesz dodać maksymalnie 3 kalkulacje.');

                this.showCalculationsList();
                return;
            }
        }

        this.personal_calculatios_array.push(this.current_personal_calculation);
        localStorage.setItem('calculations', JSON.stringify(this.personal_calculatios_array));
        this.notyf.success('Kalkulacja zapisana.');
        this.showCalculationsList();

    }

    showCalculationsList()
    {
        document.querySelector('[data-calculations-table-list]').innerHTML = '';
        let current_data = JSON.parse(localStorage.getItem('calculations'));
        let that = this;
        let download_btn = document.querySelector('[data-download-compare-finances]');

        if (!current_data || current_data === '' || current_data.length === 0) {
            download_btn.style.display = 'none';
            return;
        }

        download_btn.style.display = 'inline-flex';


        current_data.forEach(function (car, index) {

            let clone = that.compare_column_html_template.content.cloneNode(true);
            clone.querySelector('[data-title]').innerText = 'Skoda ' + car.name;
            clone.querySelector('[data-thumb]').src = car.thumb.url;

            let slide = document.createElement('div');
            slide.classList.add('swiper-slide', 'sm:w-1/3');
            slide.style.cssText = 'padding: 0 16px';

            let wrapper = document.createElement('div');
            let list = clone.querySelector('[data-car-calc-personal-summary]');
            let list_points = document.createDocumentFragment();
            let excluded_keys = [];
            let car_loans_info_list = {};

            for (var key in car) {
                if (excluded_keys.includes(key) || key == 'thumb' || key == 'name' || key == 'own_contribution_percentage') {
                    continue;
                }

                if (car.hasOwnProperty(key)) {
                    let point = document.createElement('li');
                    point.classList.add('flex', 'justify-between', 'items-start', 'space-x-4', 'border-b', 'border-grayscale-500', 'py-4', 'last:border-0');
                    let title = '';
                    let html = '';

                    point.dataset.key = key;

                    if (car.hasOwnProperty(key + '_title')) {
                        title = car[key + '_title'];
                    }
                    if (car.hasOwnProperty(key + '_html')) {
                        html = car[key + '_html'];
                    }

                    excluded_keys.push(key, key + '_title', key + '_html')
                    point.innerHTML = '<span>' + title + '</span>' + '<span class="font-bold">' + html + '</span>';

                    car_loans_info_list[key] = point;
                    console.log("-> car_loans_info_list", car_loans_info_list);
                }
            }

            let info_order = ['rate', 'price-netto', 'price', 'loans', 'own_contribution', 'km_limit']

            info_order.forEach((name) => {
                if (car_loans_info_list.hasOwnProperty(name)) {
                    list_points.appendChild(car_loans_info_list[name]);
                }
            });


            list.appendChild(list_points);

            let icon = that.returnSVGRemoveIcon();

            let remove_btn = document.createElement('button');
            remove_btn.innerHTML = icon + '<span style="margin-left: 0.5rem; font-weight: bold; font-size: 0.875rem">USUŃ Z PORÓWNANIA</span>';
            remove_btn.style.cssText = 'display: flex; align-items: center; justify-content: flex-start';
            remove_btn.classList.add('hover:opacity-80', 'mt-8', 'exclude-clone');
            remove_btn.dataset.removeFromFinanceCompare = index;


            remove_btn.addEventListener('click', () => {
                let element_index = remove_btn.dataset.removeFromFinanceCompare;
                let current_data = JSON.parse(localStorage.getItem('calculations'));
                current_data.splice(element_index, 1);
                localStorage.setItem('calculations', JSON.stringify(current_data));
                that.showCalculationsList();
            })


            let remove_btn_place = clone.querySelector('[data-remove-btn]');
            remove_btn_place.appendChild(remove_btn);

            wrapper.appendChild(clone);
            slide.appendChild(wrapper);
            document.querySelector('[data-calculations-table-list]').appendChild(slide);

        });
    }

    thumbSlider()
    {

        let that = this;

        this.slider = new Swiper(".car-finance-thumbs", {
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                }
            },
        });


        this.slider.on('slideChange', function () {
            // const active_slide = document.querySelector('.swiper-slide-active');

            console.log(that.slider.activeIndex);

            const slide = that.slider.el;

            const car = that.cars[that.slider.activeIndex];
            that.selected_car = that.setCurrentCar(car.dataset.financeCar);
            that.toggleCarFocus(that.selected_car.index);
            that.updateCalculation();
            that.updateBruttoPriceViewInCals(that.selected_car.price);

        });

    }


    calcsSlider()
    {

        if (window.innerWidth > 768) {
            return false;
        }

        let slider = new Swiper(".js-calcs-slider", {
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            slidesPerView: 1,
            watchSlidesProgress: true,
        });
    }

    returnSVGRemoveIcon()
    {

        return '<?xml version="1.0" encoding="iso-8859-1"?>\n' +
        '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" heigh="20px" x="0px" y="0px"\n' +
        '\t viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" fill="#F11010">\n' +
        '<g>\n' +
        '\t<g>\n' +
        '\t\t<path d="M256,0C114.508,0,0,114.497,0,256c0,141.493,114.497,256,256,256c141.492,0,256-114.497,256-256\n' +
        '\t\t\tC512,114.507,397.503,0,256,0z M256,472c-119.384,0-216-96.607-216-216c0-119.385,96.607-216,216-216\n' +
        '\t\t\tc119.384,0,216,96.607,216,216C472,375.385,375.393,472,256,472z"/>\n' +
        '\t</g>\n' +
        '</g>\n' +
        '<g>\n' +
        '\t<g>\n' +
        '\t\t<path d="M343.586,315.302L284.284,256l59.302-59.302c7.81-7.81,7.811-20.473,0.001-28.284c-7.812-7.811-20.475-7.81-28.284,0\n' +
        '\t\t\tL256,227.716l-59.303-59.302c-7.809-7.811-20.474-7.811-28.284,0c-7.81,7.811-7.81,20.474,0.001,28.284L227.716,256\n' +
        '\t\t\tl-59.302,59.302c-7.811,7.811-7.812,20.474-0.001,28.284c7.813,7.812,20.476,7.809,28.284,0L256,284.284l59.303,59.302\n' +
        '\t\t\tc7.808,7.81,20.473,7.811,28.284,0C351.398,335.775,351.397,323.112,343.586,315.302z"/>\n' +
        '\t</g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '<g>\n' +
        '</g>\n' +
        '</svg>\n';

    }


    checkPageType()
    {
        if (document.body.classList.contains('page-template-page-finances')) {
            return true;
        }
        return false;
    }
}
